'use client'

import type { FC } from 'react'
import styles from '../../FooterLink.module.scss'
import { openCookiesAdvancedConfigPopup } from '@/tools/cookies-blocker/service'
import { useLocalisation } from '@/tools/i18n/client'
import { Hyperlink } from '@/tools/ui'

export const FooterCookiesConfig: FC = () => {
  const { t } = useLocalisation()

  const handleClick = openCookiesAdvancedConfigPopup

  return (
    <div className={styles.customLink} id="#config-cookies-button" onClick={handleClick}>
      <Hyperlink
        className={'pintxo-typography-body2'}
        href="#config-cookies-button"
        label={t('footer_cookies_configure')}
      />
    </div>
  )
}
